import Nullable from '@/utils/Nullable';

export default class Colors {
  static get primary(): Nullable<string> {
    const element = window.document.getElementById('primary-color');
    if (element == null) {
      return null;
    }
    return window.getComputedStyle(element, null).getPropertyValue('background-color');
  }

  static get primaryReverse(): Nullable<string> {
    const element = window.document.getElementById('primary-color-reverse');
    if (element == null) {
      return null;
    }
    return window.getComputedStyle(element, null).getPropertyValue('background-color');
  }

  static get primaryLight(): Nullable<string> {
    const element = window.document.getElementById('primary-color-light');
    if (element == null) {
      return null;
    }
    return window.getComputedStyle(element, null).getPropertyValue('background-color');
  }

  static get secondary(): Nullable<string> {
    const element = window.document.getElementById('secondary-color');
    if (element == null) {
      return null;
    }
    return window.getComputedStyle(element, null).getPropertyValue('background-color');
  }

  static get secondaryReverse(): Nullable<string> {
    const element = window.document.getElementById('secondary-color-reverse');
    if (element == null) {
      return null;
    }
    return window.getComputedStyle(element, null).getPropertyValue('background-color');
  }

  static get actions(): Nullable<string> {
    const element = window.document.getElementById('actions-color');
    if (element == null) {
      return null;
    }
    return window.getComputedStyle(element, null).getPropertyValue('background-color');
  }

  static get info(): Nullable<string> {
    const element = window.document.getElementById('background-color');
    if (element == null) {
      return null;
    }
    return window.getComputedStyle(element, null).getPropertyValue('background-color');
  }

  static get success(): Nullable<string> {
    const element = window.document.getElementById('success-color');
    if (element == null) {
      return null;
    }
    return window.getComputedStyle(element, null).getPropertyValue('background-color');
  }

  static get warning(): Nullable<string> {
    const element = window.document.getElementById('warning-color');
    if (element == null) {
      return null;
    }
    return window.getComputedStyle(element, null).getPropertyValue('background-color');
  }

  static get error(): Nullable<string> {
    const element = window.document.getElementById('error-color');
    if (element == null) {
      return null;
    }
    return window.getComputedStyle(element, null).getPropertyValue('background-color');
  }

  static get geofences(): Nullable<string> {
    const element = window.document.getElementById('geofences-color');
    if (element == null) {
      return null;
    }
    return window.getComputedStyle(element, null).getPropertyValue('background-color');
  }
}
